import "magnific-popup";

// GALLERY IMAGE
function wpGallery(){
    document.querySelectorAll('.gallery[class*="gallery-columns-"]').forEach(gallery => {
        const galleryLinks = gallery.querySelectorAll('a');
        
        if (galleryLinks.length) {
            $(galleryLinks).magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                mainClass: 'wp-default-gallery',
                image: {
                    verticalFit: true,
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1]
                }
            });
        }
    });
}

export { wpGallery };
